import React from 'react'
import HomeContent from '../Components/HomeContent'

function Home() {
    return (
        <>
            <HomeContent />
        </>
    )
}

export default Home;
